import { render, staticRenderFns } from "./midestartquest.vue?vue&type=template&id=c98a5624&scoped=true&"
import script from "./midestartquest.vue?vue&type=script&lang=js&"
export * from "./midestartquest.vue?vue&type=script&lang=js&"
import style0 from "./midestartquest.vue?vue&type=style&index=0&id=c98a5624&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c98a5624",
  null
  
)

export default component.exports